let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3KeA9")).then(() => parcelRequire('9QQr7'));